import { AccordionContext } from "components/utils/Accordion/Accordion.context";
import CTAButton from "components/utils/Button/CTAButton";
import { RecordSetting } from "components/utils/Table/_Table.settings";
import { MatchDatasourceIdentifierRecord } from "data/MatchDatasourceIdentifierRecord";
import { Routing } from "helpers/routing";
import React, { useContext } from "react";
import { CheckIcon, EllipsisHIcon } from "styles/fontAwesome";

export const Settings = (
  id?: {
    tournament?: string
    match?: string
  }
): RecordSetting<MatchDatasourceIdentifierRecord> => [
  {
    accessor: 'id',
    className: 'table-hidden',
  },
  {
    accessor: 'is_enabled',
    Header: 'Enabled',
    className: 'table-enabled',
    Cell: function CellContent({ row }: any) {
      return <>{row.values.is_enabled && <CheckIcon />}</>
    }
  },
  {
    accessor: 'identifier',
    Header: 'Identifier'
  },
  {
    accessor: 'identifier_kind',
    Header: 'Identifier kind'
  },
  {
    accessor: 'admin_note',
    Header: 'Admin Note'
  },
  {
    id: 'ctaButton',
    sticky: 'right',
    className: 'table-cta-button',
    Header: function HeaderContent({ row }: any) {
      const { toggle } = useContext(AccordionContext)

      return (
        <CTAButton onClick={toggle}>
          <EllipsisHIcon />
        </CTAButton>
      )
    },
    Cell: function CellContent({ row }: any) {
      return (
        <CTAButton path={
          Routing.getMatchDatasourceIdentifierDetailUrl({
              match: id?.match ?? Routing.NewRecordSymbol,
              tournament: id?.tournament ?? Routing.NewRecordSymbol,
              matchDatasourceIdentifier: row.values.id ?? Routing.NewRecordSymbol
            })
          }>
          {row.values.isFrozen ? 'View' : 'Edit'}
        </CTAButton>
      )
    },
  },
]

export default Settings
